export default __webpack_public_path__ + "static/media/etapa2.d80f0da1.png";